import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

// ----------------------------------------------------------------------

export default function AccountRemoveSuccessful() {
  return (
    <>
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center'
            }}
        >
            <Helmet >
                <title> Matalinong Panonood</title>
            </Helmet>

            <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "30px",
                            marginBottom: "30px",
                        }}
                    >
                       <Typography
                            variant="subtitle1"
                            component="div"
                            sx={{ fontSize: '1.2rem' }}                           
                        >
                            Account Successfully Removed
                        </Typography>
                    </Box>
        </div>

    </>
  );
}
